import { fun_PostAction, fun_Download } from "@/api/index";
import {fun_DownloadFile} from "@/utils/validate";
import { Loading } from "element-ui";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 全局加载
      fullLoading: null,
      // 列表loading状态
      loading: false,
      // 查询表单字段
      form: {
        prjName: null, // 项目名称
        regulators: null, // 招标投标监管部门
        bidOpenTimeStart: null, // 开标开始时间
        bidOpenTimeEnd: null, // 开标结束时间
        bidTimeStart: null, // 中标开始时间
        bidTimeEnd: null, // 中标结束时间
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "prjName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "招标投标监管部门：",
          value: "regulators",
          placeholder: "请输入",
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201512241646570002"
          },
        },
        {
          type: "date",
          label: "开标开始时间：",
          dateType: "date",
          value: "bidOpenTimeStart",
          placeholder: "请输入",
          valueFormat: "yyyy-MM-dd",
        }, 
        {
          type: "date",
          label: "开标结束时间：",
          dateType: "date",
          value: "bidOpenTimeEnd",
          placeholder: "请输入",
          valueFormat: "yyyy-MM-dd",
        },

        {
          type: "date",
          label: "中标开始时间：",
          dateType: "date",
          value: "bidTimeStart",
          placeholder: "请输入",
          valueFormat: "yyyy-MM-dd",
        }, 
        {
          type: "date",
          label: "中标结束时间：",
          dateType: "date",
          value: "bidTimeEnd",
          placeholder: "请输入",
          valueFormat: "yyyy-MM-dd",
        },
      ],
      // 表格按钮
      btnList: [
        {
          name: "台帐导出",
          type: "success",
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          minWidth: "280",
          fixed: true
        },
        {
          label: "标段",
          prop: "section",
          minWidth: "80",
          fixed: true
        },
        {
          label: "状态",
          prop: "stateName",
          minWidth: "80",
          fixed: true
        },
        {
          label: "发布状态",
          slotName: "isReleaseState",
          minWidth: "120",
          fixed: true
        },
        {
          label: "公示状态",
          slotName: "publicState",
          minWidth: "120",
          fixed: true
        },
        {
          label: "招标范围",
          prop: "tenderContent",
          minWidth: "120",
        },
        {
          label: "招标方式",
          prop: "tenderTypeName",
          minWidth: "120",
        },
        {
          label: "建设单位",
          prop: "tenderCorp",
          minWidth: "250",
        },
        {
          label: "中标单位",
          prop: "corpName",
          minWidth: "250",
        },
        {
          label: "中标价（万元）",
          prop: "winningPrice",
          minWidth: "160",
        },
        {
          label: "开标时间",
          prop: "bidOpeningTime",
          minWidth: "170",
        },
        {
          label: "中标时间",
          prop: "bidTime",
          minWidth: "170",
        },
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 勾选的数组
      multipleSelection: [],
    };
  },
  // 注册组件
  components: {},

  // 模板编译完成
  mounted() {
    // 获取一览
    this.fun_GetList();
  },

  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/bidStandingBook/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      // 全局加载
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)"
      });
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author shuhua
     */
    fun_click(e) {
      switch (e) {
        case "台帐导出":
          this.fun_ImportExcel();
          break;
        default:
          "";
      }
    },
    /**
     * 台帐导出的方法
     * @author shuhua
     */
    fun_ImportExcel() {
      // 全局加载
      this.fun_Loading();
      try {
        // 请求，获取结果集
        fun_Download("/bidStandingBook/export", {
          ...this.form,
        }).then(res => {
          // 关闭加载
          this.fullLoading.close();
          // 获取到Content-Disposition;filename
          let fileNames = res.headers["content-disposition"];
          if (fileNames) {
            let regFileNames = fileNames.match(/=(.*)$/)[1];
            // 调用下载文件公共方法
            fun_DownloadFile(res, decodeURIComponent(regFileNames));
            // 关闭加载
            this.loading = false;
          } else {
            // 关闭加载
            this.loading = false;
            // 提示请求失败消息
            this.$message.error("文件不存在！");
          }
        });
      } catch {
      }
    },
  }
};
